<!-- //
字典码值转换
用法三种类型，如果dictStyle优先级高于type
<dict-tag dictType="EmployeeStatus" :options="{type: 'span'}" :value="text"></dict-tag>
<dict-tag dictType="EmployeeStatus" :options="{type: 'tag'}" :value="text"></dict-tag>
<dict-tag dictType="EmployeeStatus" :options="{type: 'badge'}" :value="text"></dict-tag>
<dict-tag dictType="EmployeeStatus" :value="text"></dict-tag>
@auth xuyd
@date 2022-11-01
//-->
<template>
  <div>
    <template v-for="(value, index) in values">
      <template v-if="mapData[value]">
        <template v-if="mapData[value].raw.dictStyle">
          <el-tag v-if="opts.type === 'tag'"
                  :type="mapData[value].raw.dictStyle"
                  :key="index">
            {{ mapData[value][opts.labelField] }}{{ opts.suffix }}
          </el-tag>
          <span v-else :key="value" :class="mapData[value].raw.dictStyle">
            {{ mapData[value][opts.labelField] }}{{ opts.suffix }}
          </span>
        </template>
        <span v-else :key="value">{{ mapData[value][opts.labelField] }}{{ opts.suffix }}</span>
      </template>
      <template v-else>
        <span v-bind:key="value">{{ value }}</span>
      </template>

      <template v-if="index < values.length - 1">
        {{ opts.separator }}
      </template>
    </template>
  </div>
</template>

<script>
const _opts = {
  valueField: 'dictValue',
  labelField: 'dictLabel',
  separator: '|',
  suffix: '', // 后缀
};
export default {
  name: "DictTag",
  props: {
    options: {
      type: Object,
      default: function () {
        return {}
      }
    },
    value: [Number, String, Boolean, Array],
    data: {
      type: Array,
      default: function () {
        return []
      }, // [dictItem, dictItem]
    },
    dictType: String
  },
  computed: {
    values() {
      let v
      if (this.value !== null && typeof this.value !== 'undefined') {
        v = Array.isArray(this.value) ? this.value : (this.value + '').split(',');
      } else {
        v = [];
      }
      // console.log("-------", v)
      return v
    },
    opts() {
      return this.$util.mergeObject(_opts, this.options)
    },
    mapData() {
      if (this.dictType) {
        // console.log("---mapData-dictType---", this.data);
        return this.$store.getters.dictTypeMap[this.dictType]
      } else {
        console.log("---mapData-data---", this.data);
        return this.$util.listToMap(this.data, {idField: this.opts.valueField})
      }
    }
  },
};
</script>
<style scoped>
</style>
